import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import { motion } from "framer-motion";
import { useRef, useState } from "react";
import useIsMobile from "@hooks/useIsMobile";
import { useActiveCardDetection } from "@/pages/checkout/pre-checkout/how-to-finance/hooks/useActiveCardDetection";
var FinanceSteps = function FinanceSteps(_ref) {
  var financeSteps = _ref.financeSteps;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var containerRef = useRef(null);
  var _useState = useState(0),
    activeIndex = _useState[0],
    setActiveIndex = _useState[1];
  var isMobile = useIsMobile();
  var steps = (financeSteps === null || financeSteps === void 0 ? void 0 : financeSteps.steps) || [];
  useActiveCardDetection({
    containerRef: containerRef,
    isMobile: isMobile,
    setActiveIndex: setActiveIndex
  });

  // Fixed: Create animation config for individual cards
  var getCardConfig = function getCardConfig(cardIndex) {
    if (!isMobile) {
      return {
        scale: 1,
        opacity: 1
      };
    }
    return {
      scale: activeIndex === cardIndex ? 1.25 : 1,
      opacity: activeIndex === cardIndex ? 1 : 0.6
    };
  };
  var renderDescription = function renderDescription(description) {
    var _description$images;
    if ((description === null || description === void 0 ? void 0 : description.text) !== '' && ((description === null || description === void 0 ? void 0 : (_description$images = description.images) === null || _description$images === void 0 ? void 0 : _description$images.length) == 0 || !(description !== null && description !== void 0 && description.images))) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, description === null || description === void 0 ? void 0 : description.text);
    }
    if ((description === null || description === void 0 ? void 0 : description.text) !== '' && description !== null && description !== void 0 && description.images && description !== null && description !== void 0 && description.images.length) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "flex gap-1 flex-wrap justify-center items-center"
      }, /*#__PURE__*/React.createElement("div", null, description === null || description === void 0 ? void 0 : description.text), /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2 flex-wrap justify-center w-full"
      }, description.images.map(function (img, idx) {
        return /*#__PURE__*/React.createElement("img", {
          key: idx,
          src: img,
          alt: "step-".concat(idx),
          className: "object-contain shrink-0",
          width: 40,
          height: 14,
          loading: "lazy"
        });
      }))));
    }
    if (description !== null && description !== void 0 && description.images && description !== null && description !== void 0 && description.images.length) {
      return /*#__PURE__*/React.createElement("div", {
        className: "flex gap-2 flex-wrap justify-center"
      }, description.images.map(function (img, idx) {
        return /*#__PURE__*/React.createElement("img", {
          key: idx,
          src: img,
          alt: "step-".concat(idx),
          className: "object-fit",
          width: 40,
          height: 14,
          loading: "lazy"
        });
      }));
    }
  };
  if (!steps.length || !financeSteps) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-10 px-4 md:py-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:max-w-[625px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-center text-primary-old text-base font-bold md:text-xl"
  }, financeSteps === null || financeSteps === void 0 ? void 0 : financeSteps.title), /*#__PURE__*/React.createElement("div", {
    className: "w-full rounded-full h-1 bg-red-500/20 overflow-hidden md:hidden"
  }, /*#__PURE__*/React.createElement(motion.div, {
    className: "h-full bg-[#EC6234] rounded-full",
    initial: {
      width: 0
    },
    animate: {
      width: "".concat((activeIndex + 1) / steps.length * 100, "%")
    },
    transition: {
      duration: 0.8,
      ease: [0.4, 0, 0.2, 1],
      // Custom easing for smooth animation
      type: "tween"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-px text-center justify-center text-gray-500 text-xs font-semibold md:hidden"
  }, /*#__PURE__*/React.createElement("span", null, tShort("pre-checkout/step", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null, activeIndex + 1), /*#__PURE__*/React.createElement("span", null, tShort("pre-checkout/from", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", null, steps === null || steps === void 0 ? void 0 : steps.length))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: "flex gap-10 sm-only:overflow-x-scroll snap-x snap-mandatory px-[50%] w-full py-8 md:grid md:gap-4 md:grid-cols-3 md:overflow-x-unset md:p-0"
  }, steps.map(function (step, index) {
    return /*#__PURE__*/React.createElement(motion.div, {
      key: index,
      "data-card": true,
      className: "",
      animate: getCardConfig(index) // Fixed: pass index to get individual config
      ,
      transition: {
        type: "spring",
        stiffness: 200,
        damping: 20
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-56 h-fit min-h-40 relative bg-white rounded-lg shadow-[0px_0px_8px_0px_rgba(81,81,81,0.12)] outline outline-[0.50px] outline-offset-[-0.50px] overflow-hidden shrink-0 snap-center flex flex-col items-center justify-center md:w-full px-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-28 h-28 left-[271px] top-[225px] absolute origin-top-left -rotate-180 opacity-20 rounded-full border-8 border-solid  border-offset-[-4px] border-[#EC6234]"
    }), /*#__PURE__*/React.createElement("div", {
      className: "opacity-95 text-center text-blue-800 text-4xl font-extrabold"
    }, String(index + 1).padStart(2, "0")), /*#__PURE__*/React.createElement("div", {
      className: "text-center text-blue-800 text-sm font-bold md:leading-normal"
    }, step.title), /*#__PURE__*/React.createElement("div", {
      className: "text-center text-slate-500 text-xs font-semibold"
    }, renderDescription(step === null || step === void 0 ? void 0 : step.description)), /*#__PURE__*/React.createElement("div", {
      className: "w-16 h-16 left-[37px] top-[44px] absolute origin-top-left -rotate-180  rounded-full opacity-[9%] border-[12px] border-solid outline-offset-[-6px] border-[#EC6234]"
    })));
  }))))));
};
export default FinanceSteps;